import React from 'react';
import { Box, FormGroup, Label, LabelText, Code, CopiedMessage } from '@zen-common/components-base';
import { useCopy } from '@zen/common-react-hooks';

export default function MessageBodyFormGroup({ value }) {
  const [copied, copyError, onCopy] = useCopy({ value });

  const handleCopyMsgBody = () => {
    if (value) {
      onCopy();
    }
  };

  return (
    <FormGroup>
      <Label>
        <LabelText>Message Body</LabelText>
      </Label>
      <CodeWrapper onClick={handleCopyMsgBody}>
        <Code code={value} lang="yaml" />
      </CodeWrapper>
      <CopiedMessage copied={copied} error={copyError} />
    </FormGroup>
  );
}

const CodeWrapper = (props) => <Box bg="bg4" minHeight="100px" p="smd" {...props} />;
